<template>
  <div>
    <ui-alert
      v-if="showCookieBanner"
      position="bottom"
      no-icon
      full-width
    >
      <template #description>
        <button type="button" class="close" aria-label="Close" @click="handleClose">
          <svg-alert-close/>
        </button>
        <div class="text-center">
          <small v-html="i18n.alertText" />
          <ui-button
            class="mx-2"
            :label="i18n.iAccept"
            @click="handleConfirm">
          </ui-button>
        </div>

      </template>
    </ui-alert>
  </div>
</template>

<script>
import {privacyCookieName} from '../utils';

export default {
  components: {
    UiButton: () => import(/* webpackChunkName: "chunk-ui-button" */ '../components/ui/ui-button.vue'),
    UiAlert: () => import(/* webpackChunkName: "chunk-ui-alert" */ '../components/ui/ui-alert.vue'),
    SvgAlertClose: () => import(/* webpackChunkName: "chunk-svg-alert-close" */ '../components/svg/alert-close.vue'),

  },
  props: {
    cookieUrl: {
      type: String,
      required: true,
    }
  },
  data() {
    let alert_text_translation = gettext('This website allows the use of first-party and third-party cookies to provide you with a better experience. By clicking on "I accept" button you consent to the use of cookies. To learn more or to manage your cookie preferences, please see our <a data-href="%(cookie_url)s">Cookie Policy</a>')
    return {
      privacyCookie: !!this.$cookies.get(privacyCookieName) || false,
      i18n: {
        iAccept: gettext("I accept"),
        alertText: alert_text_translation.replace("%(cookie_url)s", this.cookieUrl),
      }
    };
  },
  computed: {
    showCookieBanner() {
      return !this.privacyCookie
    },
  },
  methods: {
    handleConfirm() {
      this.$cookies.set(
        privacyCookieName,
        '1',
        '1d',
        '/',
        locations.cookie_domain);

      this.$root.$emit('setPrivacyCookie', true);

      this.privacyCookie = true;
    },
    handleClose() {
      this.privacyCookie = true;
    }
  }
}
</script>
